// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"26a056ec","823":"ff90984c"}[chunkId] + ".chunk.js";
};